module.exports = __webpack_public_path__ + "fonts/sign-on-widget-spinner.eea28db2b98f4df40b5608a54d0b9131.gif?";


//////////////////
// WEBPACK FOOTER
// ./~/@okta/okta-signin-widget/dist/img/ui/indicators/sign-on-widget-spinner.gif
// module id = 805
// module chunks = 9